import React, { useEffect, useState } from 'react'
import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles(() => ({
  scrollContainer: {
    height: 16,
    overflowX: 'scroll',
    overflowY: 'hidden',
    scrollbarWidth: 'thin',
    scrollbarColor: 'rgba(0,0,0,0.25) transparent',
    '&::-webkit-scrollbar': {
      height: 8,
    },
    '&::-webkit-scrollbar-track': {
      background: 'transparent',
    },
    '&::-webkit-scrollbar-thumb': {
      background: 'rgba(0,0,0,0.25)',
      borderRadius: 4,
      '&:hover': {
        background: 'rgba(0,0,0,0.4)',
      }
    }
  }
}))

const MpciScrollBar = React.forwardRef(({ onScroll, tableContentRef, className, ...rest }, ref) => {
  const [width, setWidth] = useState(0)
  const classes = useStyles()

  useEffect(() => {
    const timer = setTimeout(() => { setWidth(tableContentRef.current?.offsetWidth ?? 0) }, 300)
    return () => clearTimeout(timer)
  }, [tableContentRef.current?.offsetWidth])

  return (
    <div className={`${classes.scrollContainer}${className ? ` ${className}` : ''}`} onScroll={onScroll} ref={ref} {...rest}>
      <div style={{ width, height: '100%' }} />
    </div>
  )
})

MpciScrollBar.displayName = 'MpciScrollBar'

export default MpciScrollBar
